/**
 * Returns value in the current session language
 * @param object
 * @param language
 * @returns {string}
 */
export let translateObject = (objectToTranslate = {}, language = '') => {
  const object = typeof objectToTranslate === 'string' ? JSON.parse(objectToTranslate) : objectToTranslate;
  let result = '';
  for (let value in object) {
    if (value === language) {
      result = object[value];
    }
  }
  if (!result) {
    result = object[Object.keys(object)[0]];
  }
  return result;
};

/**
 * Parse to JSON and translate the object
 * into the current language
 * @param plain
 * @param language
 * @returns {function(*, *)}
 */
export let translatePlainObject = (plain = '', language = '') => {
  let object = JSON.parse(plain);
  return translateObject(object, language);
};
